export default "__VITE_ASSET__GirftJgt__"